import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class KastleInvalidFieldError extends CodedError {
  static get errorName() {
    return errorCodes.kastleInvalidFieldError.code;
  }

  constructor(message: string = errorCodes.kastleInvalidFieldError.message) {
    super(message);
    this.code = errorCodes.kastleInvalidFieldError.code;
    this.message = `${message} ${errorCodes.kastleInvalidFieldError.code}`;
    this.name = errorCodes.kastleInvalidFieldError.name;
  }
}
